export const nameRegex = /^[가-힣]{2,10}$/;

export const userIdRegex = /^(?=.*[a-z])[a-z0-9]{6,20}$/;

export const passwordRegex =
  /^(?=.*[a-z])(?=.*[0-9])(?=.*[!@#$%^&*(),.?":{}|<>])[a-z0-9!@#$%^&*(),.?":{}|<>]{8,20}$/;

export const birthDateRegex = /^(19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])$/;

export const phoneNumberRegex = /^010\d{7,8}$/;
